module.exports = __webpack_public_path__ + "images/a4491537309afab18c2956e96ac8a894.png";